import { Address as GQLItem } from '../../generated/graphql';
import { take } from '../../util';

export type Address = {
  country: string;
  city: string;
  state: string;
  street1: string;
  street2?: string;
  postalCode: string;
};

export const fromGQL = (item: GQLItem): Address =>
  take<Address>(item, 'country', 'city', 'state', 'street1', 'street2', 'postalCode');
